module.exports = __webpack_public_path__ + "static/media/concept-using-cloud-online-system-is-convenient-economical-energy-saving-low-cost.6fd5802b.jpg";